import { Reveal, MapPath, Splash } from "./decor";

const accents = ["#0066FF", "#FF6B00", "#FFD600", "#00C853", "#0066FF"];

export const MethodManifesto = ({ t }) => {
  return (
    <section id="method" className="relative overflow-hidden bg-white py-24 lg:py-32">
      <MapPath className="left-1/2 top-40 hidden h-[600px] w-24 -translate-x-1/2 lg:block" />
      <Splash className="right-[-120px] top-10 h-[360px] w-[360px]" color="#FFD600" />

      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <p className="mb-4 text-sm font-bold uppercase tracking-[0.35em] text-[#FF6B00]">
            {t.method.eyebrow}
          </p>
          <h2 className="max-w-3xl font-display text-4xl font-black leading-tight tracking-tight text-black sm:text-5xl">
            {t.method.title}
          </h2>
          <p className="mt-5 max-w-xl text-base text-black/60 lg:text-lg">{t.method.subtitle}</p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {t.method.chapters.map((c, i) => (
            <Reveal
              key={c.n}
              delay={(i % 3) * 0.1}
              className={i === 0 ? "lg:col-span-2" : ""}
            >
              <div
                className="group relative h-full overflow-hidden rounded-3xl border border-black/10 bg-[#FAFAFA] p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_60px_-24px_rgba(0,0,0,0.25)]"
                data-testid={`method-card-${c.n}`}
              >
                <span
                  className="font-display text-6xl font-black leading-none"
                  style={{ color: accents[i] }}
                >
                  {c.n}
                </span>
                <h3 className="mt-5 font-display text-2xl font-black tracking-tight text-black">
                  {c.jp}
                </h3>
                <p className="mt-1 text-sm font-semibold uppercase tracking-wider text-black/40">
                  {c.en}
                </p>
                <p className="mt-4 text-base leading-relaxed text-black/65">{c.desc}</p>
                <span
                  className="absolute -bottom-8 -right-6 h-24 w-24 rounded-full opacity-10 blur-lg transition-opacity duration-300 group-hover:opacity-25"
                  style={{ backgroundColor: accents[i] }}
                />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
